import React from "react";
import "../styles/AboutUs.css";
import bannerImage from "../assets/hero_2.png"; // Replace with your banner image
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AboutPartners from './Patners';

export default function AboutUs() {
    const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
    return (
      <div className="about-us-page">
        {/* Banner */}
        <section
          className="about-banner"
          style={{ backgroundImage: `url(${bannerImage})` }}
        >
          
            <h1 className="fade-in">About Oxford Exports</h1>
         
        </section>
  
        {/* Content Section */}
        <section className="about-content">
          <div className="container">
            <p>
            Oxford Exports specialize in enabling high-value Petroleum and Petrochemical transactions by connecting a curated network of qualified, credible buyers and sellers across the Middle East, Europe, East Africa, and East Asia.
            </p>
  
            <p>
            As a trusted first point of engagement, Oxford Exports undertakes rigorous initial due diligence on all prospective counterparties to verify credibility, financial strength, and transaction readiness. This disciplined approach streamlines the procurement process while ensuring secure, efficient, and results-driven collaborations between vetted buyers and dependable suppliers.
            </p>
  
            <p>
            In light of our expanding portfolio, increasing market demand, and ongoing efforts to strengthen our global footprint, we are keen to explore a strategic trading affiliation and identify mutually beneficial avenues of cooperation with your esteemed organization.
            </p>
  
            {/* Vision Section */}
            <div className="single-column-section" id="vision">
              <h2>Our Vision</h2>
              <p>
                Seamless Energy solutions, Empowering Energy Trade, Trusted Global
                connections
              </p>
              <p>
                At Oxford Exports, we envision a world where energy trade is
                seamless, efficient, and sustainable. We strive to be the trusted
                partner for businesses navigating the complex global petroleum
                market, connecting buyers and sellers, and facilitating
                transactions with integrity and expertise.
              </p>
              <ul>
                <li>Foster a culture of innovation, transparency, and reliability</li>
                <li>Build lasting relationships with clients, partners, and stakeholders</li>
                <li>Drive growth and prosperity in the energy sector</li>
                <li>Contribute to a more sustainable energy future</li>
              </ul>
            </div>
  
            {/* Mission Section */}
            <div className="single-column-section" id="mission">
              <h2>Our Mission</h2>
              <p>
                "To facilitate seamless petroleum transactions, foster strong
                relationships, and drive growth for our clients and partners,
                while promoting a sustainable energy future."
              </p>
              <p>We achieve this by:</p>
              <ul>
                <li>Empowering energy trade through expertise, innovation, and partnerships.</li>
                <li>Connecting markets, delivering value, and driving growth.</li>
                <li>Your trusted partner in petroleum trade, committed to excellence and sustainability.</li>
                <li>Building trust through transparency, reliability, and integrity</li>
                <li>Delivering exceptional service and value to our clients and partners</li>
              </ul>
            </div>
            <section>
            <AboutPartners />
            </section>
          </div>
        </section>
      </div>
    );
  }